/**
 * This pipe is used to disable a row in the table based on the function passed to it.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isRowDisabled',
  standalone: true,
})
export class TableRowDisabledPipe implements PipeTransform {
  transform(row: Record<string, any>, fun: (row: Record<string, any>) => boolean): boolean {
    return fun?.(row) ?? false;
  }
}
